//@ts-check
import Modals from '../../../../modal';
import fieldsLogic from '../logic/fieldsLogic';
/**
 * @param {import("../logic/types").EcrionFormState} state
 * @param {import("./types").FormField} field
 */

var editField = function editField(state, dispatch, field) {
  var formField = state.fields[field.id];
  var pageField = findFieldPage(state, formField);
  if (!pageField || !formField) return; // cannot edit a readonly field

  if (formField.readonly) return;
  var hiddenField = state.meta[field.id] && state.meta[field.id].hidden;
  var hiddenPage = state.meta[pageField.id] && state.meta[pageField.id].hidden;
  !hiddenPage && dispatch({
    type: 'SET_ACTIVE_PAGE',
    payload: pageField.id
  });
  !hiddenPage && !hiddenField && dispatch({
    type: 'SET_ACTIVE_FIELD',
    payload: formField.id
  });

  switch (formField.type) {
    case 'signature':
      editSignatureField(state, dispatch, formField);
      break;
  }
};
/**
 * @param {import("../logic/types").EcrionFormState} state
 * @param {import("../logic/types").EcrionFormField} field
 * @return {import("../logic/types").EcrionFormField}
 */


var findFieldPage = function findFieldPage(state, field) {
  var pageField = field;

  while (pageField && pageField.type !== 'page') {
    pageField = state.fields[pageField.parentId];
  }

  return pageField;
};
/**
 * @param {import("../logic/types").EcrionFormState} state
 * @param {import("../logic/types").EcrionFormSignatureField} field
 */


var editSignatureField = function editSignatureField(state, dispatch, field) {
  var agreement = field.agreement,
      recipientName = field.recipientName,
      recipientRole = field.recipientRole;
  var signature = state.data[field.id] || null;
  Modals.open({
    type: 'SIGNATURE_DIALOG',
    props: {
      onSubmit: function onSubmit(signature) {
        fieldsLogic.onChange(field.id, signature, dispatch);
      },
      signature: signature,
      agreement: agreement,
      recipientName: recipientName,
      recipientRole: recipientRole
    }
  });
};

export default editField;